// Duplicado standalone de packages/hce/src/hce/facturacion/reasonReference.ts
// — mismo criterio que extensiones.ts en esta misma carpeta: hce-chart no
// depende del paquete @logiacare/hce, así que los helpers puros compartidos
// se portan solos en vez de importarse entre paquetes.
//
// Trazabilidad `reasonReference` (MedicationRequest → Condition) para
// auditorías de glosa de aseguradoras privadas: hoy no existe ningún
// selector de UI que capture qué `Condition` motivó la receta — este helper
// solo arma el array cuando SÍ hay un id concreto; conectarlo a una UI de
// selección de diagnóstico es una decisión de producto aparte.
import type { Condition, Reference } from '@medplum/fhirtypes';

export function reasonReferenceDeCondicion(conditionId: string | null | undefined): Reference<Condition>[] | undefined {
  if (!conditionId) return undefined;
  return [{ reference: `Condition/${conditionId}` }];
}
